var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (message) {
buf.push("<div class=\"tt-message\"><span class=\"typeahead-suggestion-name\">" + (jade.escape(null == (jade_interp = message) ? "" : jade_interp)) + "</span></div>");}.call(this,"message" in locals_for_with?locals_for_with.message:typeof message!=="undefined"?message:undefined));;return buf.join("");
};
module.exports = template;